import { initializationThreeKitDataT } from "../..";
import { TYPE_REDUCER } from "../utils/constants";


type setInitializationThreeKitT = {
  initializationThreekit: initializationThreeKitDataT
}
export const setInitializationThreeKit = (data: setInitializationThreeKitT) => ({
  type: TYPE_REDUCER.SET_INITIALIZATION_THREEKIT,
  payload: data,
});
export const setAllSettingConfig = (data: any) => ({
  type: TYPE_REDUCER.SET_ALL_SETTING_CONFIG,
  payload: data,
});
export const setMainStep = (data: any) => ({
  type: TYPE_REDUCER.CHANGE_STEP,
  payload: data,
});
export const setView = (data: any) => ({
  type: TYPE_REDUCER.CHANGE_VIEW,
  payload: data,
});
export const setModalSwitching = (data: any) => ({
  type: TYPE_REDUCER.MODAL_SWITCHING,
  payload: data,
});

export const setValueOptions = (data: any) => ({
  type: TYPE_REDUCER.SET_VALUE_OPTIONS,
  payload: data,
});
export const setSideOptionsArray = (data: any) => ({
  type: TYPE_REDUCER.SET_SIDE_OPTION_ARRAY,
  payload: data,
});
export const setValueMultipleOptions = (data: any) => ({
  type: TYPE_REDUCER.SET_VALUE_MULTIPLE_OPTIONS,
  payload: data,
});

export const updateSettings = (data: any) => ({
  type: TYPE_REDUCER.UPDATE_SETTINGS,
  payload: data,
});
export const showNotification = (data: any) => ({
  type: TYPE_REDUCER.SHOW_NOTIFICATION,
  payload: data,
});
export const setActiveThreekitParams = (data: any) => ({
  type: TYPE_REDUCER.SET_ACTIVE_THREEKIT_PARAMS,
  payload: data,
});
export const closeNotification = (data: any) => ({
  type: TYPE_REDUCER.CLOSE_NOTIFICATION,
  payload: data,
});
export const setOpenSectionIdInSides = (data: any) => ({
  type: TYPE_REDUCER.SET_OPEN_SECTION_ID_IN_SIDES,
  payload: data,
});
export const removeTempSectionInSides = (data: any) => ({
  type: TYPE_REDUCER.REMOVE_TEMP_SECTION,
  payload: data,
});
